import { NUMBER_FILTER_PARAMS, TEXT_FILTER_PARAMS } from '@/pages/Studies/utils/sharedColumnDefs';
import type { SampleProteoformPublic } from '@/types';
import type { ColDef } from 'ag-grid-enterprise';

type TFunction = (key: string) => string;

const stub = (colId: string): ColDef<SampleProteoformPublic> => ({
  colId,
  headerName: colId,
  resizable: true,
  sortable: false,
  filter: false,
});

export function buildRunSampleDetailsColDefs(t: TFunction): ColDef<SampleProteoformPublic>[] {
  return [
    stub('Flowcell'), // TODO: no field in SampleProteoformPublic — add when run-scoped endpoint ships
    stub('Lane'), // TODO: no field in SampleProteoformPublic
    {
      field: 'well_position',
      headerName: t('col_well'),
      filter: 'agTextColumnFilter',
      filterParams: TEXT_FILTER_PARAMS,
      resizable: true,
      sortable: true,
    },
    {
      field: 'demux_index',
      headerName: t('col_demux_id'),
      filter: 'agNumberColumnFilter',
      filterParams: NUMBER_FILTER_PARAMS,
      resizable: true,
      sortable: true,
    },
    {
      field: 'sample_name',
      headerName: t('col_sample'),
      filter: 'agTextColumnFilter',
      filterParams: TEXT_FILTER_PARAMS,
      resizable: true,
      sortable: true,
    },
    stub('Sample Groups'), // TODO: sample_group not in SampleProteoformPublic
    {
      field: 'proteoform_name',
      headerName: t('col_proteoform_group'),
      filter: 'agTextColumnFilter',
      filterParams: TEXT_FILTER_PARAMS,
      resizable: true,
      sortable: true,
    },
    {
      field: 'proteoform_abundance',
      headerName: t('col_abundance'),
      filter: 'agNumberColumnFilter',
      filterParams: NUMBER_FILTER_PARAMS,
      resizable: true,
      sortable: true,
      valueFormatter: ({ value }: { value: number | null | undefined }) => value?.toLocaleString() ?? '',
    },
    // Terminus + PTM stub columns — no API backing yet.
    // TODO: replace with real field bindings when run-scoped endpoint exposes these fields.
    stub('N Terminus'),
    stub('0N'),
    stub('1N'),
    stub('2N'),
    stub('3R'),
    stub('4R'),
    stub('C Terminus'),
    stub('pT181'),
    stub('pS202+PT205'),
    stub('pT205'),
    stub('pS214'),
    stub('pT217'),
    stub('pT231'),
    stub('pS396'),
  ];
}
